import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

//  Routes 

import { getDoctorRecentFiles, getFolderData, getFolderDataByPath, getPatientsFolder, getPatientSharedDoctorsFolder, getPatientSharedFilesByDoctor, searchFileExplorer, serveFile } from '../../../../../routes/doctor/files';

// Redux 

import { setInitialRendering, setCurrentFolder, setFolderData, selectFile, selectFolder, setLastInternalFileIndex,  setRefreshFileExplorer, setIsDropdownOpened, setMouseInfo, setUnconfirmedDraggedFile, setMode, setSearchSection, setLastSearchSection, setFolderView, setFolderDataBeforeQuery, setSearchQuery } from '../../../../../redux/features/doctor/Dashboard/documents/fileExplorer';
import { setBlobFileUrl, setFileExtension, setFileName, setIsFileViewerOpened, setSelectedFile } from '../../../../../redux/features/doctor/Dashboard/documents/fileViewer';

// Assets 

import protectedPaths from '../folders/protectedPaths';

// Components 

import FolderDataRow from './FolderDataRow';

import { default as MuiList } from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { resetEditFolder } from '../../../../../redux/features/doctor/Dashboard/documents/editFolder';
import { resetEditFile, setEditedFile } from '../../../../../redux/features/doctor/Dashboard/documents/editFile';
import { getMetaPatientInfo } from '../../../../../routes/doctor/patients';
import FolderDataBox from './FolderDataBox';
import { setPatientId } from '../../../../../redux/features/doctor/Dashboard/consultation/savedConsultation';

const List: React.FC = () => {
    
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation();

    const colors = useAppSelector(state => state.theme.colors);
    const folderData = useAppSelector((state) => state.fileExplorer.folderData); 
    const searchSection = useAppSelector((state) => state.fileExplorer.searchSection); 
    const lastSearchSection = useAppSelector((state) => state.fileExplorer.lastSearchSection); 
    const directory = useAppSelector((state) => state.fileExplorer.directory); 
    const folderDataBeforeQuery = useAppSelector((state) => state.fileExplorer.folderDataBeforeQuery); 
    const searchQuery  = useAppSelector((state) => state.fileExplorer.searchQuery); 
    const refreshFileExplorer = useAppSelector((state) => state.fileExplorer.refreshFileExplorer); 
    const isOpened = useAppSelector((state) => state.createFolder.isOpened); 
    const isDropdownOpened = useAppSelector((state) => state.fileExplorer.isDropdownOpened); 
    const selectedFolder = useAppSelector((state) => state.fileExplorer.selectedFolder);
    const selectedFile = useAppSelector((state) => state.fileExplorer.selectedFile); 
    const currentFolder = useAppSelector((state) => state.fileExplorer.currentFolder); 
    const folderView = useAppSelector((state) => state.fileExplorer.folderView); 
    const initialRendering = useAppSelector((state) => state.fileExplorer.initialRendering); 
    const downloadsFolder = useAppSelector((state) => state.fileExplorer.downloadsFolder); 

    // Template Upload

    const isComingFromTemplateEditing = useAppSelector((state) => state.fileExplorer.isComingFromTemplateEditing); 
    const selectedPatient = useAppSelector((state) => state.template.selectedPatient);

    const mode = useAppSelector((state) => state.fileExplorer.mode); 
    const file = useAppSelector((state) => state.uploadFile.file); 

    // -- 

    const handleSearch = async () => { 

        if (searchQuery === 'no-search') { 

            if (folderDataBeforeQuery.length > 0)  {

                dispatch(setFolderData(folderDataBeforeQuery)); 

            }; 

            dispatch(setLastInternalFileIndex(null)); 

        } else { 

            const res = await searchFileExplorer(currentFolder, searchQuery) as any; 

            if (res?.data.status === 200) { 

                dispatch(setFolderDataBeforeQuery(folderData)); 

                if (res.data.dataList.length > 0) { 

                    let newFolderData = [] as any; 
                    
                    const filteredList = folderData.filter((data: any) => { 

                        if (data._doc.title.includes(searchQuery)) { 

                            newFolderData.push(data); 

                            return data; 

                        }; 

                    }); 

                    dispatch(setLastInternalFileIndex(filteredList.length - 1)); 

                    res.data.dataList.forEach((data: any) => { 

                        newFolderData.push(data); 

                    }); 

                    dispatch(setFolderData(newFolderData));

                }; 
        
            };

        }; 

    }; 

    // -- 

    const handleFileSelection = async (e: any, item: any) => { 

        if (e.detail === 2) { 

            if ((mode === 'moveFile') || (mode === 'moveFolder')) { 

                if ((item.type === 'folder') && (selectedFolder?._id != item._doc._id) && (!item._doc.path.startsWith(selectedFolder?.path))) { 

                    dispatch(setCurrentFolder(item._doc)); 

                }; 

                return; 

            } else if (mode === 'attachFileToConsultation') { 

                if (item.type === 'rootSharedFolder') { 

                    return; 
                }; 

            }; 

            if (item.type === 'file') { 

                dispatch(selectFile(item._doc)); 
                dispatch(setSelectedFile(item._doc)); 
                dispatch(setIsFileViewerOpened(true)); 

                dispatch(setMode('viewFile')); 

            } else if (item.type === 'folder') { 

                dispatch(setCurrentFolder(item._doc)); 

            } else if (item.type === 'consultations') { 

                dispatch(setPatientId(item._doc.relatedPatient)); 
                
                dispatch(setMode('consultations')); 

            } else if (item.type === 'rootSharedFolder') { 

                dispatch(setSearchSection('rootSharedFolder')); 

                dispatch(setMode('sharedFolder'));

            } else if (item.type === 'rootSharedDoctorFolder') { 

                const res = await getPatientSharedFilesByDoctor(item._doc._id); 
                
                if (res?.data.status === 200) {

                    dispatch(setFolderData(res.data.dataList));
                    dispatch(setCurrentFolder(res.data.folder._doc)); 
                };

            } else if (item.type === 'sharedFolder') { 

                dispatch(setCurrentFolder(item._doc)); 
                dispatch(setMode('sharedFolder')); 

            } else if (item.type === 'sharedFile') { 

                dispatch(selectFile(item._doc)); 
                dispatch(setSelectedFile(item._doc)); 
                dispatch(setIsFileViewerOpened(true)); 

                dispatch(setMode('viewFile')); 

            }; 

            dispatch(selectFolder(null)); 

        } else if (e.detail === 1) { 

            if (file || (mode === 'editFile') || (mode === 'editFolder') || (mode === 'moveFile') || (mode === 'moveFolder')) { 

                return; 

            }; 

            if (item.type === 'file') { 

                dispatch(selectFolder(null)); 
                dispatch(selectFile(item._doc)); 

            } else if (item.type === 'folder') { 

                if (protectedPaths.includes(item._doc.path)) { 

                    dispatch(selectFolder(null)); 

                } else { 

                    dispatch(selectFile(null)); 
                    dispatch(selectFolder(item._doc)); 

                }; 

            } else if (item.type === 'consultations') { 

                return; 

            }; 

            if ((selectedFile && (item._doc._id !== selectedFile?._id)) || (selectedFolder && (item._doc._id !== selectedFolder?._id))) { 

                dispatch(resetEditFile()); 
                dispatch(resetEditFolder()); 

            }; 

        };  

        if ((item.type !== 'sharedFolder') && (mode === 'sharedFolder')) { 

            dispatch(setMode(''));
        }; 

        dispatch(setIsDropdownOpened(false)); 

    }; 

    // -- 

    const handleSpecialOptions = (e: any, item: any) => { 

        if (e.button == 2) { 

            if ((mode === 'editFile') || (mode === 'moveFile')) {
                return; 
            }; 

            if (item.type === 'file') { 

                dispatch(selectFolder(null)); 
                dispatch(selectFile(item._doc)); 

            } else if (item.type === 'folder' && (!protectedPaths.includes(item._doc.path))) { 

                dispatch(selectFile(null)); 
                dispatch(selectFolder(item._doc)); 

            }; 

            if (isDropdownOpened && (selectedFile?._id === item._doc._id || selectedFolder?._id === item._doc._id)) { 

                dispatch(setIsDropdownOpened(false)); 

            } else { 

                dispatch(setIsDropdownOpened(true)); 

                dispatch(setMouseInfo({ clientX: e.clientX, clientY: e.clientY }));

            };

        }; 
        

        // -- 

        if (item.type === 'file') { 

            dispatch(setUnconfirmedDraggedFile(item._doc)); 

        }; 


    }; 

    // -- 

    const handleKeyboardOptions = (e: any, item: any) => { 

        if (e.key == ' ') { 

            if (selectedFile || selectedFolder) { 

                dispatch(selectFile(null)); 
                dispatch(selectFolder(null)); 

            }; 

        }; 

    }; 

    // --

    const getList = async () => { 

        if ((searchSection === 'recent') || !searchSection) { 

            const res = await getDoctorRecentFiles() as any; 

            if (res?.data.status === '200') { 

                dispatch(setFolderData(res.data.dataList));
                dispatch(setCurrentFolder(res.data.folder)); 
        
            }; 

        } else if (searchSection === 'rootSharedFolder' || searchSection === 'shared') {

            if (searchSection === 'shared') { 
                return; 
            }; 
            
            const res = await getPatientSharedDoctorsFolder(currentFolder.relatedPatient); 

            if (res?.data.status === 200) { 

                dispatch(setFolderData(res.data.dataList));
                dispatch(setCurrentFolder(res.data.folder._doc)); 

            }; 

        } else if (searchSection === 'rootSharedDoctorFolder') { 

            const res = await getMetaPatientInfo(currentFolder.relatedPatient, currentFolder.uploadedBy) as any; 

            if (res.data.status == 200) { 

                const result = await getPatientSharedFilesByDoctor(res.data.metaPatient._id) as any;
                
                if (result?.data.status === 200) {
    
                    dispatch(setFolderData(result.data.dataList));
                    dispatch(setCurrentFolder(result.data.folder._doc)); 
                };

            }; 
            
        } else {  

            const res = await getFolderData(searchSection); 

            if (res?.data.status === 200) { 

                dispatch(setFolderData(res.data.dataList));
                dispatch(setCurrentFolder(res.data.folder)); 

            }; 

        }; 

        searchSection ? dispatch(setLastSearchSection(searchSection)) : dispatch(setLastSearchSection('recent')); 
        
        dispatch(setRefreshFileExplorer(false)); 
        dispatch(setFolderDataBeforeQuery([])); 
        dispatch(setSearchQuery('no-search')); 

    };

    // -- 

    useEffect(() => { 

        if (searchSection && lastSearchSection) { 

            if (searchSection != lastSearchSection) { 

                getList(); 
    
            }; 

        };

    },[searchSection, lastSearchSection]);

    // -- 

    useEffect(() => { 

        if (refreshFileExplorer) { 

            getList(); 

        }; 

    },[refreshFileExplorer]); 

    // -- 

    useEffect(() => { 

        if (folderData) { 

            if (folderData.length > 0) { 

                if (searchQuery) { 

                    handleSearch(); 
        
                };

            };

        }; 

    },[searchQuery]); 

    // -- 

    useEffect(() => { 

        if (initialRendering) { 

            const view = localStorage.getItem('folderView'); 

            if (view) {

                dispatch(setFolderView(view)); 

            } else { 

                dispatch(setFolderView('box')); 

            }; 

            getList(); 

            dispatch(setInitialRendering(false)); 

        }; 

    },[initialRendering]);

    // -- 

    useEffect(() => { 

        if (isComingFromTemplateEditing && downloadsFolder) { 

            if (selectedPatient) { 

                const handleNewDirectory = async () => { 

                    const res = await getFolderDataByPath(`Patients/${selectedPatient.patientId}`);

                    if (res?.data.status === '200') {
    
                        const { folder } = res.data; 
    
                        if (folder) { 
    
                            dispatch(setCurrentFolder(folder)); 
    
                        };
    
                    };

                }; 

                handleNewDirectory(); 

            } else { 

                dispatch(setCurrentFolder(downloadsFolder)); 

            }; 

        }; 

    },[isComingFromTemplateEditing, downloadsFolder]); 

    // --

    return (

        <>

        { folderData?.length >= 1 && 

            <Box 
                
                sx={{ 
                    overflow: 'auto',
                    width: '100%',
                    height: '100%',
                    marginTop: 1, 
                    scrollbarWidth: 'none',
                }}>
        
                { folderView === 'row' &&
                
                <MuiList dense disablePadding>
        
                {folderData?.map((item, index) => (
        
                    <ListItem 
                        onClick={(e) => handleFileSelection(e, item)} 
                        onMouseDown={(e) => handleSpecialOptions(e, item)} 
                        onKeyDown={(e) => handleKeyboardOptions(e, item)}
                        button 
                        key={index} 
                        disablePadding>

                        <FolderDataRow 
                            index={index}
                            _id={item._doc._id}
                            title={item._doc.title}
                            path={item._doc.path}
                            createdAt={item._doc.createdAt}
                            updatedAt={item._doc.updatedAt}
                            type={item.type}
                            searchQuery={item.searchQuery}
                        />
       
                    </ListItem>

                ))}
        
                </MuiList>}

                { folderView === 'box' && 

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            overflowWrap: 'normal',
                            width: '100%',
                            height: '100%', 
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            scrollbarWidth: 'none',
                            transition: 'width 0.3s',
                        }}
                    >

                    {folderData?.map((item, index) => (
                            
                            <Box 
                                sx={{ maxHeight: 200 }}
                                onClick={(e) => handleFileSelection(e, item)} 
                                onMouseDown={(e) => handleSpecialOptions(e, item)} 
                                onKeyDown={(e) => handleKeyboardOptions(e, item)}
                                key={index} 
                            >

                                <FolderDataBox 
                                    index={index}
                                    _id={item._doc._id}
                                    title={item._doc.title}
                                    path={item._doc.path}
                                    createdAt={item._doc.createdAt}
                                    updatedAt={item._doc.updatedAt}
                                    fileUrl={item._doc.fileUrl}
                                    type={item.type}
                                    searchQuery={item.searchQuery}
                                />

                            </Box>

                        ))}

                    </Box>
                
                }
        
            </Box>}

            {(folderData?.length === 0 && !isOpened) &&   
          
                <Box
                    sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                        width: '100%',
                        height: '100%',
                    }}>

                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>

                            <Box
                                sx={{
                                    width: 150,
                                    marginBottom: 2
                                }}
                                component="img"
                                alt="Solutions Medca Inc."
                                src={require('../../../../../assets/icons/files/empty-folder.png')}
                            />

                            <Box sx={{ 
                                color: 'rgb(150, 150, 150)',
                                fontSize: 12,
                                textAlign: 'center'
                            }}>{t('emptyFolder')}</Box>

                        </Box>
                


                </Box>}

          </>

    );

};

export default List;